import { Spinner } from "./loader.styles";

export const Loader: React.FC = (): JSX.Element => {
  return <Spinner />;
};
